import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'formly-field-calendar',
    template: `<div>
    <p-calendar
      [class.ng-dirty]="showError"
      [formControl]="formControl"
      [showIcon]="true"
      [selectionMode]="to.selectionMode ?? 'single'"
      [dateFormat]="to.dateFormat ?? 'dd/mm/yy'"
      [timeOnly]="to.timeOnly"
      [dataType]="to.dataType ?? 'date'"
      [showTime]="to.showTime"
      [formlyAttributes]="field"
      appendTo="body"
    >
    </p-calendar></div>
  `,
})
// tslint:disable-next-line:component-class-suffix
export class FormlyFieldCalendar extends FieldType {

}
